// @ts-nocheck
import translate from "@insite/client-framework/Translate";
import TextField, { TextFieldPresentationProps } from "@insite/mobius/TextField";
import uniqueId from "@insite/mobius/utilities/uniqueId";
import {
    useTrailerTrackingV2DebouncedUpdateDraftParameter,
    useTrailerTrackingV2State,
} from "@store/Framework/Store/Greif/Pages/TrailerTrackingV2/TrailerTrackingV2Hooks";
import FilterDrawerSection from "@store/Library/Components/FilterDrawerSection";
import { filterDrawerProps } from "@store/Themes/common/props/filterDrawer";
import React, { FC, useEffect, useMemo, useState } from "react";

export interface TrailerTrackingV2FilterFieldPoNumberProps {}

export interface TrailerTrackingV2FilterFieldPoNumberStyles {
    textField?: TextFieldPresentationProps;
}

export const trailerTrackingV2FilterFieldPoNumberStyles: TrailerTrackingV2FilterFieldPoNumberStyles = {
    textField: filterDrawerProps.textField,
};

const styles = trailerTrackingV2FilterFieldPoNumberStyles;

const TrailerTrackingV2FilterFieldPoNumber: FC<TrailerTrackingV2FilterFieldPoNumberProps> = () => {
    const { poNumber } = useTrailerTrackingV2State().draftParameter;
    const debouncedUpdateDraftParameter = useTrailerTrackingV2DebouncedUpdateDraftParameter();
    const [value, setValue] = useState(poNumber);
    const id = useMemo(uniqueId, []);

    useEffect(() => {
        if (value !== poNumber) {
            setValue(poNumber);
        }
    }, [poNumber]);

    return (
        <FilterDrawerSection title={translate("PO #")} labelFor={id}>
            <TextField
                {...styles.textField}
                id={id}
                onChange={event => {
                    setValue(event.currentTarget.value);
                    debouncedUpdateDraftParameter({ poNumber: event.currentTarget.value });
                }}
                placeholder={translate("Enter PO #")}
                value={value}
            />
        </FilterDrawerSection>
    );
};

export default TrailerTrackingV2FilterFieldPoNumber;
